import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type MatterEventCategory } from "@/lib/data/static/matters/matter-event";
import { type APIResponse, type MatterEvent } from "@/lib/types";

export type RetrieveMatterEventsParams = {
  matterId: string;
  pageNumber?: number;
  pageSize?: number;
  actorUserId?: string[];
  actorIntegrationAppId?: string[];
  itemType?: MatterEventCategory[];
  dateCreatedAfter?: string;
  dateCreatedBefore?: string;
  search?: string;
  sortDirection?: "asc" | "desc";
};

export const retrieveMatterEventsV3 = ({
  matterId,
  pageNumber = 1,
  pageSize = 1000,
  ...filters
}: RetrieveMatterEventsParams) => {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<MatterEvent[]>>(`matters/v3/${matterId}/events`, {
      params: { ...filters, pageNumber, pageSize },
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data);
};
